import AuthProvider from "core/contexts/auth/AuthProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import { QueryClient, QueryClientProvider } from "react-query";
import PageRoutes from "./core/routes/Routes";

/**
 * The MUI `ThemeProvider` that used to wrap these routes carried exactly one
 * setting: `MuiGrid2.defaultProps.disableEqualOverflow`. Nothing in the app has
 * rendered a Grid2 since task 1, and nothing renders any MUI component now, so
 * the provider was configuring a component that no longer existed -- while
 * still pulling @mui/material, and Emotion behind it, into every page load.
 *
 * `createTheme(theme)` was also called on a value that was already a theme, on
 * every render, which rebuilt the whole theme object each time.
 */
function App() {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <PageRoutes />
        <ToastContainer hideProgressBar={true} position={"bottom-right"} newestOnTop={true} limit={3} />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
